/*
 * @Author: Ryan
 * @Date: 2025-12-04
 * @Description: 声音切换按钮组件，用于视频展示区的静音/取消静音切换
 */
import React from 'react';

interface SoundToggleProps {
  isMuted: boolean;
  onToggle: () => void;
}

const SoundToggle: React.FC<SoundToggleProps> = ({ isMuted, onToggle }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="w-[34px] h-[34px] flex items-center justify-center hover:scale-105 transition-transform duration-200 focus:outline-none"
      aria-label={isMuted ? 'Unmute' : 'Mute'}
    >
      {isMuted ? (
        // 静音图标 (Frame 2) - 有斜线
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 7.5C16.3116 7.77825 16.5941 8.08985 16.8421 8.4294C17.5694 9.4252 18 10.6611 18 12C18 13.3273 17.5768 14.5534 16.8609 15.5447C16.6084 15.8943 16.3196 16.2147 16 16.5"
            stroke="#3366FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.1182 20.5931C20.042 18.8479 22.0002 15.6527 22.0002 12.0002C22.0002 8.40447 20.1024 5.25197 17.2537 3.48975"
            stroke="#3366FF"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="1.29669"
            y1="0.895613"
            x2="17.7967"
            y2="22.6456"
            stroke="#3366FF"
            strokeWidth="2"
          />
          <path
            d="M13 20.5107V21C13 21.5523 12.5523 22 12 22C9.82379 22 8.04891 20.5953 6.91211 19.3984C6.32419 18.7795 5.85785 18.1646 5.53906 17.7061C5.46725 17.6028 5.40293 17.5067 5.3457 17.4199H3C1.96449 17.4199 1.11317 16.6325 1.01074 15.624L1 15.4199V8.50586C1 7.62987 1.56364 6.88682 2.34766 6.61621L13 20.5107ZM12 2C12.5523 2 13 2.44772 13 3V17.2236L4.78223 6.50586H5.35059C5.4078 6.42055 5.47219 6.32615 5.54395 6.22461C5.86311 5.773 6.3296 5.16691 6.91797 4.55762C8.05716 3.37801 9.83052 2.00001 12 2Z"
            fill="#3366FF"
          />
        </svg>
      ) : (
        // 取消静音图标 (Frame 1) - 有声音波纹
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 3V21C8.5 21 5.89925 16.4195 5.89925 16.4195H3C2.44771 16.4195 2 15.9718 2 15.4195V8.5054C2 7.9531 2.44771 7.5054 3 7.5054H5.89925C5.89925 7.5054 8.5 3 12 3Z"
            fill="#3366FF"
            stroke="#3366FF"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M16 7.5C16.3116 7.77825 16.5941 8.08985 16.8421 8.4294C17.5694 9.4252 18 10.6611 18 12C18 13.3273 17.5768 14.5534 16.8609 15.5447C16.6084 15.8943 16.3196 16.2147 16 16.5"
            stroke="#3366FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.118 20.5928C20.0418 18.8476 22 15.6525 22 12C22 8.40422 20.1021 5.25172 17.2535 3.4895"
            stroke="#3366FF"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )}
    </button>
  );
};

export default SoundToggle;
